import { List } from 'immutable';
import { isSelTouchingLastBlock } from './isSelTouchingLastBlock';


export const topLevelBlocksInSel = (value, opts = {}) => {
  const { document: doc } = value;

  const { withTrim = false } = opts;
  const shouldBeTrimmed = withTrim && isSelTouchingLastBlock(value);
  const blocks = (shouldBeTrimmed
    ? value.blocks.pop()
    : value.blocks
  );

  const topLevelBlocks = blocks.reduce(
    (all, block) => (
      all.push(doc.getFurthestBlock(block.key) || block)
    ),
    new List()
  );

  return topLevelBlocks;
};



// WEBPACK FOOTER //
// ./src/components/slate/utils/topLevelBlocksInSel.js